import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useForm } from "react-hook-form";
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import SweetAlert from 'sweetalert2';
import LoadingComponent from "../../components/common/LoadingComponent";
import NoDataHandler from "../../components/common/NoDataHandler";


const Brand = () => {
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
    const [data, setData] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [brandImage, setBrandImage] = useState(null);
    const [existingImageUrl, setExistingImageUrl] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [brandFecthLoading, setBrandFetchLoading] = useState(false);

    useEffect(() => {
        getData();
    }, []);

    const getData = () => {
        setBrandFetchLoading(true);
        setData([]); // Reset data before fetching new data

        axiosConfig.get("brand-list", setHeader())
            .then((res) => {
                setData(res.data.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setBrandFetchLoading(false);
            });
    };
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        const input = e.target;

        if (!file) return;

        const maxSize = 200 * 1024; // 200KB

        // Check file size
        if (file.size > maxSize) {
            SweetAlert.fire({
                title: "Validation Error",
                text: "File size must be 200KB or less.",
                icon: "warning",
            }).then(() => {
                input.value = ""; // Clear the file input
            });
            return;
        }

        // Check image dimensions
        const img = new Image();
        img.onload = () => {
            if (img.width > 300 || img.height > 200) {
                SweetAlert.fire({
                    title: "Validation Error",
                    text: "Image dimensions must be at most 300px wide and 200px tall.",
                    icon: "warning",
                }).then(() => {
                    input.value = ""; // Clear the file input
                });
                return;
            }

            // ✅ All validations passed
            setBrandImage(file);
        };

        img.onerror = () => {
            SweetAlert.fire({
                title: "Invalid Image",
                text: "Could not load the image.",
                icon: "error",
            }).then(() => {
                input.value = ""; // Clear the file input
            });
        };

        img.src = URL.createObjectURL(file);
    };



    const onSubmit = data => {
        if (data !== '') {
            setIsLoading(true);

            // Create FormData for handling file upload
            const formData = new FormData();
            formData.append("name", data.name);
            formData.append("desc", data.desc || "");
            formData.append("status", data.status ? 1 : 0);
            formData.append("brand_order", data.brand_order || "");


            if (editMode) {
                formData.append("id", editId);

                // Handle image for edit mode
                if (brandImage) {
                    // New image selected
                    formData.append("brand_image", brandImage);
                } else if (existingImageUrl) {
                    // Keep existing image
                    formData.append("existing_image_url", existingImageUrl);
                    formData.append("keep_existing_image", "1");
                }

                for (let pair of formData.entries()) {
                    console.log(pair[0] + ": " + pair[1]);
                }

                axiosConfig.post(`update-brand/${editId}`, formData, setHeader()).then((res) => {
                    setIsLoading(false);
                    if (res.data.error && res.data.messages === 'Brand name already exists!') {
                        SweetAlert.fire({
                            title: "Error",
                            text: "Brand name already exists!",
                            icon: "warning",
                        });
                        return; // STOP here
                    }
                    if (!res.data.error) {
                        SweetAlert.fire({ title: "Success", text: "Updated Successfully", icon: "success" });
                        resetForm();
                        getData();
                    } else {
                        SweetAlert.fire({ title: "Oops!", text: "Failed to update. Try again!", icon: "error" });
                    }
                }).catch((error) => {
                    setIsLoading(false);
                    console.log(error);
                });
            } else {
                // Add mode - image is optional
                if (brandImage) {
                    formData.append("brand_image", brandImage);
                }

                for (let pair of formData.entries()) {
                    console.log(pair[0] + ": " + pair[1]);
                }

                axiosConfig.post("insert-brand", formData, setHeader()).then((res) => {
                    setIsLoading(false);
                    if (res.data.error && res.data.messages === 'Exist a Brand in this name !') {
                        SweetAlert.fire({
                            title: "Error",
                            text: "Brand name already exists!",
                            icon: "warning",
                        });
                        return; // STOP here
                    }
                    if (!res.data.error) {
                        SweetAlert.fire({ title: "Success", text: "Inserted Successfully", icon: "success" });
                        resetForm();
                        getData();
                    } else {
                        SweetAlert.fire({ title: "Oops!", text: "Failed to insert. Try again!", icon: "error" });
                    }
                }).catch((error) => {
                    setIsLoading(false);
                    console.log(error);
                });
            }

        } else {
            errors.showMessages();
        }
    };

    const resetForm = () => {
        reset();
        setBrandImage(null);
        setExistingImageUrl("");
        setEditMode(false);
        setEditId(null);

        // Reset file input
        const fileInput = document.getElementById("brandImage");
        if (fileInput) fileInput.value = "";
    };

    const editData = (id) => {
        const brandToEdit = data.find((item) => item.id === id);
        if (brandToEdit) {
            setEditMode(true);
            setEditId(id);

            // Populate form fields
            setValue("name", brandToEdit.name);
            setValue("desc", brandToEdit.description);
            setValue("status", brandToEdit.status == 1);
            setValue("brand_order", brandToEdit.brand_order || "");


            // Set existing image URL for display
            setExistingImageUrl(brandToEdit.brand_image || "");
            setBrandImage(null); // Reset file input
        }
    };

    const DeleteData = (id) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: "Once deleted, you will not be able to recover this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                axiosConfig.get(`delete-brand/${id}`, setHeader())
                    .then((res) => {
                        if (!res.data.error) {
                            SweetAlert.fire({
                                title: "Success",
                                text: res.data.messages,
                                icon: "success",
                            });
                            getData(); // Refresh the list
                        } else {
                            SweetAlert.fire({
                                title: "Oops!",
                                text: res.data.messages,
                                icon: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Error deleting data:", error);
                        SweetAlert.fire({
                            title: "Error",
                            text: "An error occurred while deleting the data.",
                            icon: "error",
                        });
                    });
            }
        });
    };
    if (brandFecthLoading || isLoading) {
        return (
            <LoadingComponent />
        );
    }
    // if (data.length === 0) {
    //     return <NoDataHandler title='No Brand Fount' />;
    // }
    return (
        <Fragment>
            <Breadcrumb title="Brand" parent="Masters" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-5">
                        <div className="card">
                            <div className="card-body">
                                <form className="needs-validation" noValidate="" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="form-row">
                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="validationCustom01">Name <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input className="form-control" name="name" type="text" placeholder="Name" {...register('name', { required: true })} />
                                            <span>{errors.name && 'Name is required'}</span>
                                            <div className="valid-feedback">{"Looks good!"}</div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label>Description</label>
                                            <textarea className="form-control" rows="3" cols="5" name="desc" placeholder="Description..." {...register('desc', { required: false })}></textarea>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="brand_order">Brand Order</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="brand_order"
                                                placeholder="Enter display order"
                                                {...register("brand_order", { required: false })}
                                            />
                                        </div>

                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="brandImage">Brand Image {editMode && "(Leave empty to keep current image)"}</label>

                                            {/* Show existing image in edit mode */}
                                            {editMode && existingImageUrl && (
                                                <div className="existing-image-preview mb-2">
                                                    <img
                                                        src={existingImageUrl}
                                                        alt="Current brand"
                                                        style={{
                                                            maxWidth: "150px",
                                                            maxHeight: "100px",
                                                            objectFit: "cover",
                                                            border: "1px solid #ddd",
                                                            borderRadius: "4px"
                                                        }}
                                                    />
                                                    <p className="text-muted mt-1 mb-0" style={{ fontSize: "12px" }}>Current Image</p>
                                                </div>
                                            )}

                                            <input
                                                type="file"
                                                id="brandImage"
                                                name="brand_image"
                                                onChange={handleImageChange}
                                                className="form-control"
                                                accept="image/*"
                                            />
                                            <small className="text-muted">Only images ≤ 200KB and dimensions ≤ 300×200px are allowed.</small>

                                            {brandImage && (
                                                <div className="file-preview mt-1">
                                                    <small className="text-info">New file selected: {brandImage.name}</small>
                                                </div>
                                            )}
                                        </div>
                                        <div className="col-md-12 checkbox checkbox-solid-primary mb-3">
                                            <input id="solid3" type="checkbox" value="1" name="status" {...register('status', { required: false })} defaultChecked />
                                            <label htmlFor="solid3">Active</label>
                                        </div>
                                    </div>
                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={isLoading}
                                    >
                                        {isLoading
                                            ? `${editMode ? 'Updating' : 'Saving'}...`
                                            : (editMode ? 'Update' : 'Save')
                                        }
                                    </button>
                                    {(editMode || brandImage) && (
                                        <button
                                            className="btn btn-secondary"
                                            style={{ marginLeft: '10px' }}
                                            type="button"
                                            onClick={resetForm}
                                            disabled={isLoading}
                                        >
                                            Reset
                                        </button>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-7">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">{"#"}</th>
                                        <th scope="col">{"Order"}</th>
                                        <th scope="col">{"Brand"}</th>
                                        <th scope="col">{"Image"}</th>
                                        <th scope="col">{"Status"}</th>
                                        <th scope="col">{"Action"}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td>{item.brand_order ?? "-"}</td>
                                                <td>{item.name}</td>
                                                <td>
                                                    {item.brand_image ? (
                                                        <img
                                                            src={item.brand_image}
                                                            alt={item.name}
                                                            style={{
                                                                width: "40px",
                                                                height: "40px",
                                                                objectFit: "cover",
                                                                borderRadius: "4px"
                                                            }}
                                                        />
                                                    ) : (
                                                        <span className="text-muted">No Image</span>
                                                    )}
                                                </td>
                                                <td>{item.status == 1 ? "Active" : "Inactive"}</td>
                                                <td>
                                                    <button title="Edit" className="btn btn-xs btn-outline-success" onClick={(e) => { editData(item.id) }}>
                                                        Edit
                                                    </button>&nbsp;
                                                    <button title="Delete" className="btn btn-xs btn-outline-danger" onClick={(e) => DeleteData(item.id)}>
                                                        Delete
                                                    </button>

                                                </td>
                                            </tr>
                                        );
                                    })}

                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>

            </div>

        </Fragment>
    );
};

export default Brand;